export const INT_SET_TEXT = 'INTERNATIONALIZATION_SET_TEXT'
